// extracted by mini-css-extract-plugin
module.exports = {"img404":"Notfound_img404__112T_"};